import { apiInstances } from '../../../../libs';

const { get } = apiInstances.routesInstance;

export default async function getEnabledRoutes({ id_clouder, routeType }) {
  return get(`/routes/today?id_clouder=${id_clouder}&route_type=${routeType}`);
}
